/**
 * 受注（回収・積替・搬入）
 * 削除
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/directly_hiddens`

const orders_accepts_directly_hidden = {
  namespaced: true,
  actions: {
    delete ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.delete(api_path).then( data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.result)
        } )
      })
    },
  },
}
export default orders_accepts_directly_hidden
